import {
  Box,
  Heading,
  StatGroup,
  Stat,
  StatLabel,
  StatNumber,
  Stack,
  Text,
  Wrap,
} from '@chakra-ui/react'
import numeral from 'numeral'

import PeopleChart from 'src/components/PeopleChart'
import { sum } from 'src/lib/utils'

const SchoolDash = ({ contents, people, last30 }) => {
  return (
    <Stack spacing={30}>
      <Box>
        <Heading size="lg" fontWeight={400}>
          Content
        </Heading>
        <Text fontSize="0.9rem" color="gray.400">
          Created in last 1 year
        </Text>
      </Box>
      <StatGroup marginX={5}>
        {contents.map((c, idx) => {
          return (
            <Stat key={idx}>
              <StatLabel>{c.type}</StatLabel>
              <StatNumber>{c.count}</StatNumber>
            </Stat>
          )
        })}
      </StatGroup>
      <Heading size="lg" fontWeight={400}>
        People
      </Heading>
      <Wrap justify="space-evenly">
        <Box height={500} width={500}>
          <Heading size="md" fontWeight={100} textAlign="center">
            Total {numeral(people.reduce(sum, 0)).format()} people
          </Heading>
          <PeopleChart people={people} />
        </Box>
        <Box height={500} width={500}>
          <Heading size="md" fontWeight={100} textAlign="center">
            {numeral(last30.reduce(sum, 0)).format()} active in last 30 days
          </Heading>
          <PeopleChart people={last30} />
        </Box>
      </Wrap>
    </Stack>
  )
}

export default SchoolDash
